import clsx from "clsx";

/**
 * Combines Tailwind classes conditionally
 */
export function cn(...inputs) {
  return clsx(...inputs);
}
